import React from 'react';
import PropTypes from 'prop-types';
import InlineSVG from 'svg-inline-react';
import classes from './Task.scss';
import { getTaskProperties } from '../../models/Task';
import ContactCard from '../ContactCard/ContactCard';
import {
  Dialog,
  Divider,
  FlatButton,
  IconButton,
  IconMenu,
  MenuItem,
} from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import EditIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import OvalIcon from '../../assets/ic_oval.svg';
import ChatIcon from '../../assets/ic-chat.svg';
import FileIcon from '../../assets/ic-files.svg';
import _ from 'lodash';

export class Task extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      alert: null,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const omit = ['saveTask', 'setTask', 'deleteTask'];

    if (
      JSON.stringify(_.omit(nextProps, omit)) !==
      JSON.stringify(_.omit(this.props, omit))
    ) {
      return true;
    }

    if (JSON.stringify(nextState) !== JSON.stringify(this.state)) {
      return true;
    }

    return false;
  }

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  getMenuItems = menulocation => {
    const items = [];

    items.push(
      <MenuItem
        key={`activity_context_${menulocation}_${this.props.task.id}_edit`}
        primaryText="Bearbeiten"
        leftIcon={<EditIcon />}
        onTouchTap={e => {
          this.props.setTask(this.props.task.id);
          this.props.closeContextMenu();
        }}
      />,
    );

    items.push(
      <Divider
        key={`task_context_${menulocation}_${this.props.task.id}_divider`}
      />,
    );
    items.push(
      <MenuItem
        primaryText="Aufgabe löschen"
        leftIcon={<DeleteIcon className="svg-icon-primary svg-icon-warning" />}
        key={`task_context_${menulocation}_${this.props.task.id}_delete`}
        className="menu-primary"
        onClick={() => {
          this.props.closeContextMenu();
          this.setState({
            alert: (
              <Dialog
                actions={[
                  <FlatButton
                    label="Abbrechen"
                    primary
                    onTouchTap={this.handleAlertClose}
                  />,
                  <FlatButton
                    label="Löschen"
                    primary
                    onTouchTap={() => {
                      this.handleAlertClose();
                      this.props.deleteTask(this.props.task.id);
                    }}
                  />,
                ]}
                modal={false}
                open
                onRequestClose={this.handleAlertClose}
              >
                Aufgabe wirklich löschen?
              </Dialog>
            ),
          });
        }}
      />,
    );
    return items;
  };

  render() {
    const extraInfo = getTaskProperties(this.props.task);
    const completedClass = this.props.task.is_done
      ? classes.completed
      : classes.open;
    let date = null;
    if (extraInfo.dueDay !== null) {
      date = <span className={classes.date}>bis {extraInfo.dueDay}</span>;
    }
    let connected = null;
    if (this.props.task.taskable_id !== null && !this.props.hideConnected) {
      connected = (
        <span className={classes.connected}>
          {this.props.task.connected.name} ({this.props.task.connected.type})
        </span>
      );
    }
    let additionalClass = null;
    if (date !== null && connected !== null) {
      additionalClass = classes.additional;
    }
    let priority = null;
    if (this.props.task.priority) {
      priority = (
        <span className={classes.priority}>
          <InlineSVG src={OvalIcon} />
        </span>
      );
    }
    let notes = null;
    if (
      typeof this.props.task.notes !== 'undefined' &&
      this.props.task.notes !== null &&
      this.props.task.notes.length
    ) {
      notes = <div className={classes.notes}>{this.props.task.notes}</div>;
    }

    let comments = null;
    if (this.props.task.comments.length) {
      comments = (
        <span className={classes.chatIcon}>
          · <InlineSVG src={ChatIcon} />
        </span>
      );
    }

    let files = null;
    if (
      typeof this.props.task.files !== 'undefined' &&
      this.props.task.files.length
    ) {
      files = (
        <span className={classes.fileIcon}>
          · <InlineSVG src={FileIcon} />
        </span>
      );
    }

    const staffCard = (
      <ContactCard
        displayType="imageOnly"
        avatar={
          typeof this.props.task.assignee !== 'undefined' &&
          this.props.task.assignee !== null
            ? this.props.task.assignee.avatar
            : ''
        }
        id={
          this.props.task.assignee_id !== null
            ? this.props.task.assignee_id
            : ''
        }
        name={
          typeof this.props.task.assignee !== 'undefined' &&
          this.props.task.assignee !== null
            ? this.props.task.assignee.name
            : ''
        }
        type="staff"
      />
    );

    return (
      <section
        className={`${classes.task} ${completedClass}`}
        onContextMenu={e =>
          this.props.openContextMenu(e, this.getMenuItems('contextmenu'))
        }
      >
        <div className={classes.check}>
          <input
            type="checkbox"
            checked={this.props.task.is_done}
            onChange={() =>
              this.props.saveTask({
                ...this.props.task,
                is_done: !this.props.task.is_done,
              })
            }
          />
        </div>
        <div
          className={classes.content}
          onClick={() => this.props.setTask(this.props.task.id)}
        >
          <a
            href="#openTask"
            onClick={e => {
              e.preventDefault();
              this.props.setTask(this.props.task.id);
            }}
          >
            {this.props.task.title}
          </a>
          <br />
          <div className={additionalClass}>
            {priority}
            {date} {comments} {files}
            <br />
            {connected}
          </div>
          {notes}
        </div>
        <div className={classes.buttonArea}>
          {staffCard}
          <IconMenu
            iconButtonElement={
              <IconButton>
                <MoreVertIcon />
              </IconButton>
            }
            anchorOrigin={{
              horizontal: 'right',
              vertical: 'bottom',
            }}
            targetOrigin={{
              horizontal: 'right',
              vertical: 'top',
            }}
            style={{
              padding: 0,
            }}
          >
            {this.getMenuItems('iconmenu')}
          </IconMenu>
        </div>
        {this.state.alert}
      </section>
    );
  }
}
Task.propTypes = {
  task: PropTypes.object.isRequired,
  setTask: PropTypes.func.isRequired,
  saveTask: PropTypes.func.isRequired,
  deleteTask: PropTypes.func.isRequired,
  hideConnected: PropTypes.bool,
  openContextMenu: PropTypes.func,
  closeContextMenu: PropTypes.func,
};
export default Task;



// WEBPACK FOOTER //
// ./src/components/Task/Task.js